import api from './api';

/**
 * Service API pour la gestion des authentifications 3DS des décisions admin
 * Système complètement isolé du flux de résolution amiable
 */
class AdminPaymentAuthService {
  
  /**
   * Récupérer la demande d'auth pour un dispute
   * GET /api/v1/admin-payment-auth/by-dispute/:disputeId
   */
  async getByDisputeId(disputeId) {
    const response = await api.get(`/admin-payment-auth/by-dispute/${disputeId}`);
    return response.data.data;
  }

  /**
   * Confirmer que le renter a validé le 3DS
   * POST /api/v1/admin-payment-auth/:authRequestId/confirm
   */
  async confirmAuthentication(authRequestId, paymentIntentId) {
    const response = await api.post(`/admin-payment-auth/${authRequestId}/confirm`, {
      payment_intent_id: paymentIntentId
    });
    return response.data.data;
  }

  /**
   * Annuler une demande d'auth
   * POST /api/v1/admin-payment-auth/:authRequestId/cancel
   */
  async cancel(authRequestId, reason = null) {
    const response = await api.post(`/admin-payment-auth/${authRequestId}/cancel`, {
      reason
    });
    return response.data.data;
  }

  /**
   * Récupérer mes demandes en attente
   * GET /api/v1/admin-payment-auth/my-pending
   */
  async getMyPending() {
    const response = await api.get('/admin-payment-auth/my-pending');
    return response.data.data;
  }

  // ═══════════════════════════════════════════════════════════════
  // ADMIN TOOLS
  // ═══════════════════════════════════════════════════════════════

  /**
   * [ADMIN] Lister les dossiers 3DS avec filtres et pagination
   * GET /api/v1/admin-payment-auth/admin/list
   */
  async adminList({ status, search, page = 1, limit = 20 } = {}) {
    const params = { page, limit };
    if (status) params.status = status;
    if (search) params.search = search;
    const response = await api.get('/admin-payment-auth/admin/list', { params });
    return response.data.data;
  }

  /**
   * [ADMIN] Statistiques globales du dashboard 3DS
   * GET /api/v1/admin-payment-auth/admin/stats
   */
  async adminStats() {
    const response = await api.get('/admin-payment-auth/admin/stats');
    return response.data.data;
  }

  /**
   * [ADMIN] Relancer la notification vers le renter
   * POST /api/v1/admin-payment-auth/admin/:authRequestId/resend
   */
  async adminResend(authRequestId) {
    const response = await api.post(`/admin-payment-auth/admin/${authRequestId}/resend`);
    return response.data.data;
  }

  /**
   * [ADMIN] Marquer un dossier comme traité manuellement
   * POST /api/v1/admin-payment-auth/admin/:authRequestId/manual
   */
  async adminMarkManual(authRequestId, notes = '') {
    const response = await api.post(`/admin-payment-auth/admin/${authRequestId}/manual`, { notes });
    return response.data.data;
  }

  /**
   * [ADMIN] Changer manuellement le statut d'une demande d'auth
   * POST /api/v1/admin-payment-auth/admin/:authRequestId/status
   */
  async adminUpdateStatus(authRequestId, newStatus, reason = '') {
    const response = await api.post(`/admin-payment-auth/admin/${authRequestId}/status`, {
      newStatus,
      reason
    });
    return response.data.data;
  }
}

export default new AdminPaymentAuthService();
